import React, {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import AutoComplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
const DrugPayDr = (props) => {
    const {did} = useParams();
    const [patientData, setPatientData] = useState([]);
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
    const [opbillData, setopbillData] = useState([]);
    const [consData, setConsData] = useState([]);
    const [disc, setDisc] = useState(0);
    const [viewPharmData, setViewPharmData] = useState([]);
    const [lres, setLres] = useState([]);
    const [lnet, setLnet] = useState([]);
    const [items, setItems] = useState([]);
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [disPer, setDisPer] = useState(0);
    const [changed, setChanged] = useState(false);
    const [drugData, setDrugData] = useState([]);
    /*
     * IMPORTANT:
     * Separate refs for autocomplete and quantity inputs.
     *
     * Previously nextQtyInputRef was a single ref shared by
     * every quantity input. Therefore after selecting a newly
     * added medicine, focus could jump to the wrong quantity.
     */
    const inputRefs = useRef([]);
    const qtyInputRefs = useRef([]);
    const [pharmData, setpharmData] = useState({
        sale_id: '',
        sale_type: '',
        pat: '',
        patient: '',
        cons: '',
        product: '',
        qty: '',
        netamount: '',
        total: '',
        disc: '',
        details: '',
        paid: '',
        balance: '',
        mode: '',
        status: '',
        addedby: '',
        ip_add: '',
    });
    // ============================================================
    // FETCH DOCTOR REQUEST
    // ============================================================
    useEffect(() => {
        axios.get(baseUrl + 'view-consultform-drug/' + did + '/')
            .then(function (response) {
                setopbillData(response.data);
                if (
                    response.data &&
                    response.data.length > 0 &&
                    response.data[0].dose
                ) {
                    setLres(response.data[0].dose.split(','));
                } else {
                    setLres([]);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }, [did]);
    // ============================================================
    // FETCH PHARMACY DATA AFTER DOCTOR REQUEST
    // ============================================================
    useEffect(() => {
        if (opbillData.length > 0) {
            fetchPharmData();
            fetchPharmData1();
            fetchConsData();
        }
    }, [opbillData]);
    // ============================================================
    // FETCH EXISTING DOCTOR MEDICINES
    // ============================================================
    function fetchPharmData() {
        const ipIds = opbillData
            .flatMap(row =>
                row.drug_id
                    ? row.drug_id
                        .split(',')
                        .map(item => item.trim())
                        .filter(item => item !== '')
                    : []
            );
        const promises = ipIds.map(id =>
            axios.get(baseUrl + 'update-indent-use/' + id + '/')
                .then(response => response.data)
                .catch(error => {
                    console.log(error);
                    return null;
                })
        );
        Promise.all(promises)
            .then(dataArray => {
                const filteredDataArray = dataArray.filter(
                    data => data !== null
                );
                setViewPharmData(prevData => {
                    if (prevData.length === 0) {
                        return filteredDataArray;
                    }
                    return prevData.map(row => {
                        const matchedData = filteredDataArray.find(
                            data => row.id === data.id
                        );
                        if (matchedData) {
                            return {
                                ...row,
                                totqty: matchedData.qty
                            };
                        }
                        return row;
                    });
                });
            });
    }
    // ============================================================
    // FETCH ALL PHARMACY AUTOCOMPLETE OPTIONS
    // ============================================================
    function fetchPharmData1() {
        axios.get(`${baseUrl}indent-pharm-search/?dept=Pharmacy`)
            .then((pharmResponse) => {
                const pharmOptions = Array.isArray(pharmResponse.data)
                    ? pharmResponse.data
                    : [];
                /*
                 * REMOVE DUPLICATE MEDICINES
                 *
                 * Same medicine/product ID will appear only once
                 * in autocomplete.
                 *
                 * We use product.id rather than the stock row id,
                 * because the displayed medicine is based on
                 * option.product.product.
                 */
                const uniqueOptions = [];
                const seenProducts = new Set();
                pharmOptions.forEach(item => {
                    const productId = item?.product?.id;
                    const key =
                        productId !== undefined &&
                        productId !== null
                            ? String(productId)
                            : `${item?.product?.product || ''}|${item?.product?.batch || ''}|${item?.product?.expiry || ''}`;
                    if (!seenProducts.has(key)) {
                        seenProducts.add(key);
                        uniqueOptions.push(item);
                    }
                });
                /*
                 * Preserve existing manually added rows stock quantities
                 */
                const ipIds = rows || [];
                if (ipIds.length > 0) {
                    setViewPharmData(
                        uniqueOptions.map(row => {
                            const matchedData = ipIds.find(
                                data => data?.id === row?.id
                            );
                            if (matchedData) {
                                return {
                                    ...row,
                                    totqty: matchedData.qty
                                };
                            }
                            return row;
                        })
                    );
                } else {
                    setViewPharmData(uniqueOptions);
                }
                /*
                 * IMPORTANT:
                 * items is now the deduplicated autocomplete source.
                 */
                setItems(uniqueOptions);
            })
            .catch(error => {
                console.log(error);
            });
    }
    // ============================================================
    // EXTRA SAFETY:
    // DEDUPLICATE ITEMS BEFORE AUTOCOMPLETE
    // ============================================================
    const uniqueItems = React.useMemo(() => {
        const seen = new Set();
        return items.filter((item) => {
            const product = item?.product || {};
            const name = String(
                product.product ||
                product.name ||
                ""
            )
                .trim()
                .replace(/\s+/g, " ")
                .toLowerCase();
            const id = String(
                product.id ??
                item?.id ??
                ""
            ).trim();
            const key = `${name}||${id}`;
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }, [items]);
    // ============================================================
    // KEYBOARD HANDLING - EXISTING DOCTOR ROW
    // ============================================================
    const handleKeyDown = (e, uniqueKey) => {
        switch (e.keyCode) {
            case 16:
                e.preventDefault();
                handleAddRow();
                break;
            case 18:
                e.preventDefault();
                handleDeleteRow(e, uniqueKey);
                break;
            default:
                break;
        }
    };
    // ============================================================
    // KEYBOARD HANDLING - NEW ROW
    // ============================================================
    const handleKeyDownr = (e, rowIndex) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            case 16:
                e.preventDefault();
                handleAddRow();
                break;
            case 18:
                e.preventDefault();
                if (newRows.length > 1) {
                    newRows.splice(rowIndex, 1);
                    setRows(newRows);
                }
                break;
            case 38:
                e.preventDefault();
                if (!newRows[rowIndex]) {
                    return;
                }
                if (newRows[rowIndex].selectedItem === 0) {
                    newRows[rowIndex].selectedItem =
                        uniqueItems.length - 1;
                } else {
                    newRows[rowIndex].selectedItem--;
                }
                setRows(newRows);
                break;
            case 40:
                e.preventDefault();
                if (!newRows[rowIndex]) {
                    return;
                }
                if (
                    newRows[rowIndex].selectedItem ===
                    uniqueItems.length - 1
                ) {
                    newRows[rowIndex].selectedItem = 0;
                } else {
                    newRows[rowIndex].selectedItem++;
                }
                setRows(newRows);
                break;
            default:
                break;
        }
    };
    // ============================================================
    // KEEP ROWS UPDATED
    // ============================================================
    useEffect(() => {
        setRows(rows);
    }, [rows]);
    // ============================================================
    // FOCUS LAST AUTOCOMPLETE WHEN NEW ROW ADDED
    // ============================================================
    useEffect(() => {
        if (rows.length > 0) {
            setTimeout(() => {
                const lastIndex = rows.length - 1;
                inputRefs.current[lastIndex]?.focus();
            }, 50);
        }
    }, [rows.length]);
    // ============================================================
    // ADD NEW ROW
    // ============================================================
    const handleAddRow = () => {
        /*
         * IMPORTANT:
         *
         * Previously:
         *
         * const newRow = [{ ... }];
         *
         * This created a nested array:
         *
         * rows = [
         *   [...],
         *   [...]
         * ]
         *
         * That can cause many unpredictable issues.
         *
         * It must be a normal object.
         */
        const newRow = {
            id: '',
            product: '',
            qty: '',
            batch: '',
            expiry: '',
            totqty: '',
            uamount: '',
            netamount: ''
        };
        setRows(prevRows => [
            ...prevRows,
            newRow
        ]);
        setDrugData(prevData => [
            ...prevData,
            newRow
        ]);
    };
    // ============================================================
    // DELETE NEW ROW
    // ============================================================
    const handleDeleteRowr = (e, rowIndex) => {
        e.preventDefault();
        const newRows = [...rows];
        newRows.splice(rowIndex, 1);
        setRows(newRows);
        inputRefs.current.splice(rowIndex, 1);
        qtyInputRefs.current.splice(rowIndex, 1);
    };
    // ============================================================
    // DELETE DOCTOR MEDICINE
    // ============================================================
    const handleDeleteRow = (e, uniqueKey) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        const [rowIndex, subIndex] =
            String(uniqueKey).split('-');
        const parsedRowIndex = parseInt(rowIndex);
        const parsedSubIndex = parseInt(subIndex);
        if (
            !Number.isInteger(parsedRowIndex) ||
            !Number.isInteger(parsedSubIndex)
        ) {
            return;
        }
        const newOpbillData = [...opbillData];
        if (!newOpbillData[parsedRowIndex]) {
            return;
        }
        newOpbillData[parsedRowIndex].drug_id =
            newOpbillData[parsedRowIndex].drug_id
                .split(',')
                .filter(
                    (_, index) => index !== parsedSubIndex
                )
                .filter(item => item.trim() !== '')
                .join(',');
        const newLnet = lnet.filter(
            (_, index) => index !== parsedSubIndex
        );
        const newLres = lres.filter(
            (_, index) => index !== parsedSubIndex
        );
        setLnet(newLnet);
        setLres(newLres);
        setopbillData(newOpbillData);
    };
    // ============================================================
    // COMMON CHANGE
    // ============================================================
    const handleChange = (e, index) => {
        const {
            name,
            value
        } = e.target;
        setpharmData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const handleChanger = (e, rowIndex) => {
        const {
            name,
            value
        } = e.target;
        setpharmData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    // ============================================================
    // SELECT MEDICINE FROM AUTOCOMPLETE
    // ============================================================
    const handleSelect = (event, val, rowIndex) => {
        const selectedItem = val;
        if (!selectedItem) {
            return;
        }
        const newRows = [...rows];
        // ========================================================
        // EXPIRY CHECK
        // ========================================================
        const today = new Date();
        const expiry = new Date(
            selectedItem.product.expiry
        );
        const diffTime =
            expiry.getTime() - today.getTime();
        const diffDays =
            Math.ceil(
                diffTime /
                (1000 * 60 * 60 * 24)
            );
        if (diffDays <= 0) {
            Swal.fire(
                `${diffDays} day(s) since expired`
            );
            return;
        }
        // ========================================================
        // CHECK WHETHER MEDICINE ALREADY EXISTS
        // ========================================================
        const existingRowIndex =
            newRows.findIndex(
                row =>
                    row?.id &&
                    String(row.id) ===
                    String(selectedItem.id)
            );
        let targetRowIndex = rowIndex;
        // ========================================================
        // EXISTING MEDICINE
        // ========================================================
        if (existingRowIndex !== -1) {
            const existingRow =
                newRows[existingRowIndex];
            const currentQty =
                parseFloat(existingRow.qty) || 0;
            const stockQty =
                parseFloat(existingRow.totqty) || 0;
            const remainQty =
                stockQty - currentQty;
            if (remainQty <= 0) {
                Swal.fire("Stock not available");
                return;
            }
            const addQty =
                Math.min(1, remainQty);
            newRows[existingRowIndex] = {
                ...existingRow,
                qty:
                    currentQty + addQty,
                netamount:
                    (currentQty + addQty) *
                    (parseFloat(existingRow.uamount) || 0)
            };
            targetRowIndex =
                existingRowIndex;
        }

            // ========================================================
            // NEW MEDICINE
        // ========================================================
        else {
            /*
             * rowIndex is the newly added row.
             */
            newRows[rowIndex] = {
                id: selectedItem.id,
                product:
                selectedItem.product.product,
                batch:
                selectedItem.product.batch,
                expiry:
                selectedItem.product.expiry,
                totqty:
                selectedItem.qty,
                uamount:
                selectedItem.product.uamount,
                qty: 1,
                netamount:
                    selectedItem.product.uamount * 1
            };
            targetRowIndex = rowIndex;
        }
        // ========================================================
        // UPDATE ROWS
        // ========================================================
        setRows(newRows);
        // ========================================================
        // EXPIRY WARNING
        // ========================================================
        if (diffDays < 15) {
            Swal.fire(
                `${diffDays} day(s) to expire`
            );
        }
        // ========================================================
        // CRITICAL FIX:
        // FOCUS THE QUANTITY OF THE SELECTED ROW
        // ========================================================
        setTimeout(() => {
            if (
                qtyInputRefs.current[targetRowIndex]
            ) {
                qtyInputRefs.current[
                    targetRowIndex
                    ].focus();
                qtyInputRefs.current[
                    targetRowIndex
                    ].select();
            }
        }, 100);
    };
    // ============================================================
    // DOCTOR MEDICINE QTY CHANGE
    // ============================================================
    const handleAmountChange = (e, subIndex) => {
        const newLnet = [...lnet];
        let qty =
            parseFloat(e.target.value) || 0;
        const uamount =
            parseFloat(
                e.target.getAttribute('data-uamount')
            ) || 0;
        const totqty =
            parseFloat(
                e.target.getAttribute('data-totqty')
            ) || 0;
        if (qty > totqty) {
            Swal.fire("Stock not available");
            qty = totqty;
            const updatedQty =
                totqty.toString();
            const updatedLres =
                lres.map(
                    (item, i) =>
                        i === subIndex
                            ? updatedQty
                            : item
                );
            setLres(updatedLres);
            e.target.value =
                updatedQty;
        }
        const netamount =
            qty * uamount;
        newLnet[subIndex] =
            netamount;
        setLnet(newLnet);
    };
    // ============================================================
    // NEW MEDICINE QTY CHANGE
    // ============================================================
    const handleAmountChanger = (e, rowIndex) => {
        const newRows = [...rows];
        if (!newRows[rowIndex]) {
            return;
        }
        newRows[rowIndex].qty =
            parseFloat(e.target.value) || 0;
        newRows[rowIndex].uamount =
            parseFloat(
                newRows[rowIndex].uamount
            ) || 1;
        const netamount =
            (
                newRows[rowIndex].qty *
                newRows[rowIndex].uamount
            ).toFixed(2);
        newRows[rowIndex].netamount =
            parseFloat(netamount);
        const remainQty =
            newRows[rowIndex].totqty -
            newRows[rowIndex].qty;
        if (remainQty < 0) {
            Swal.fire(
                "Stock not available"
            );
            newRows[rowIndex].qty =
                newRows[rowIndex].totqty;
            newRows[rowIndex].netamount =
                parseFloat(
                    (
                        newRows[rowIndex].totqty *
                        newRows[rowIndex].uamount
                    ).toFixed(2)
                );
        }
        if (
            parseFloat(newRows[rowIndex].totqty) <
            10
        ) {
            Swal.fire(
                `${newRows[rowIndex].product} is less than 10 check with other Billers before proceeding`
            );
        }
        setRows(newRows);
    };
    // ============================================================
    // DISCOUNT
    // ============================================================
    const handleDisPerChange = (e) => {
        const newDisPer =
            parseFloat(e.target.value) || 0;
        setDisPer(newDisPer);
    };
    // ============================================================
    // CALCULATE TOTAL
    // ============================================================
    useEffect(() => {
        let subTotal = 0;
        let disc = 0;
        let newTotal = 0;
        subTotal =
            arraySum(lnet);
        if (rows.length > 0) {
            let subTotal1 = 0;
            for (
                let i = 0;
                i < rows.length;
                i++
            ) {
                const row =
                    rows[i];
                if (row) {
                    subTotal1 +=
                        parseFloat(
                            row.netamount
                        ) || 0;
                }
            }
            subTotal +=
                subTotal1;
        }
        disc =
            subTotal *
            (
                parseFloat(disPer) / 100
            );
        newTotal =
            subTotal - disc;
        setSubTotal(subTotal);
        setDisc(disc);
        setTotal(newTotal);
    }, [lnet, disPer, rows]);
    // ============================================================
    // ARRAY SUM
    // ============================================================
    const arraySum = (arr) => {
        return arr.reduce(
            (total, value) =>
                total +
                (
                    parseFloat(value) || 0
                ),
            0
        );
    };
    // ============================================================
    // CONSULTANT DATA
    // ============================================================
    function fetchConsData() {
        axios.get(`${baseUrl}cons-search/`)
            .then((consResponse) => {
                setConsData(
                    consResponse.data
                );
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleConsChange = (event) => {
        const {
            value
        } = event.target;
        setpharmData(prevState => ({
            ...prevState,
            cons: {
                id: value
            }
        }));
    };
    // ============================================================
    // AUTOCOMPLETE FILTER
    // ============================================================
    const customFilterOptions = (options, state) => {
        const inputValue =
            state.inputValue
                .toLowerCase()
                .trim();
        if (inputValue.length < 3) {
            return [];
        }
        return options.filter(option => {
            const label =
                (
                    option?.label ||
                    option?.product?.product ||
                    ''
                ).toLowerCase();
            return label.startsWith(
                inputValue
            );
        });
    };
    // ============================================================
    // FORM SUBMIT
    // ============================================================
    const formSubmit = (e) => {
        e.preventDefault();
        const patid =
            document.getElementById("patid")
                ?.value || '';
        const patient =
            document.getElementById("patient")
                ?.value || '';
        const dbType =
            document.getElementById("dbType")
                ?.value || '';
        const details =
            document.getElementById("details")
                ?.value || '';
        const cons =
            document.getElementById("cons")
                ?.value || '';
        const ids = [];
        let qtys = [];
        const netamounts = [];
        // ========================================================
        // DOCTOR MEDICINES
        // ========================================================
        opbillData.forEach((row) => {
            const productParts =
                row.drug_id
                    ? row.drug_id
                        .split(',')
                        .map(part => part.trim())
                        .filter(part => part !== '')
                    : [];
            const productNumbers =
                productParts.map(
                    part => Number(part)
                );
            ids.push(
                ...productNumbers
            );
            qtys.push(
                ...lres.map(Number)
            );
            netamounts.push(
                lnet
            );
        });
        // ========================================================
        // DOCTOR STOCK BALANCE
        // ========================================================
        const qtyMap = {};
        qtys.forEach((row, index) => {
            const elementId =
                `totqty-${index}`;
            const element =
                document.getElementById(
                    elementId
                );
            if (!element) {
                return;
            }
            const totqty =
                element.value;
            qtyMap[ids[index]] =
                Number(totqty) -
                qtys[index];
        });
        // ========================================================
        // NEW MEDICINES
        // REMOVE EMPTY ROWS BEFORE SUBMIT
        // ========================================================
        const validRows =
            rows.filter(
                row =>
                    row &&
                    row.id !== null &&
                    row.id !== undefined &&
                    String(row.id).trim() !== ''
            );
        const idsFromRows =
            validRows.map(
                row => row.id
            );
        const qtysFromRows =
            validRows.map(
                row => row.qty
            );
        const netamountsFromRows =
            validRows.map(
                row => row.netamount
            );
        const eqtys =
            validRows.map(
                row => row.totqty
            );
        const totqtyMap = {};
        eqtys.forEach(
            (totqty, index) => {
                const id =
                    idsFromRows[index];
                totqtyMap[id] =
                    totqty -
                    qtysFromRows[index];
            }
        );
        // ========================================================
        // DRUG DATA
        // ========================================================
        const drugData = [
            ...ids.map(
                (id, index) => ({
                    id,
                    qty: qtys[index]
                })
            ),
            ...validRows.map(
                row => ({
                    id: row.id,
                    qty: row.qty
                })
            )
        ];
        // ========================================================
        // CLEAN IDS
        // ========================================================
        const allIds = [
            ...ids,
            ...idsFromRows
        ]
            .filter(
                id =>
                    id !== null &&
                    id !== undefined &&
                    String(id).trim() !== ''
            )
            .join(',');
        // ========================================================
        // GENERATE SALE ID
        // ========================================================
        axios.post(
            `${baseUrl}get_sale_pharm/`
        )
            .then(response => {
                const sale_id =
                    response.data.value;
                const _formData =
                    new FormData();
                _formData.append(
                    'sale_id',
                    sale_id
                );
                _formData.append(
                    'sale_type',
                    'OtherBill'
                );
                _formData.append(
                    'pat',
                    patid
                );
                _formData.append(
                    'patient',
                    patient
                );
                _formData.append(
                    'cons',
                    cons
                );
                _formData.append(
                    'product',
                    allIds
                );
                _formData.append(
                    'qty',
                    qtys
                        .concat(qtysFromRows)
                        .join(',')
                );
                _formData.append(
                    'netamount',
                    netamounts
                        .concat(netamountsFromRows)
                        .join(',')
                );
                _formData.append(
                    'total',
                    total.toFixed(2)
                );
                _formData.append(
                    'disc',
                    disc.toFixed(2)
                );
                if (dbType === 'creditpay') {
                    _formData.append(
                        'paid',
                        0
                    );
                    _formData.append(
                        'balance',
                        total.toFixed(2)
                    );
                } else {
                    _formData.append(
                        'paid',
                        total.toFixed(2)
                    );
                    _formData.append(
                        'balance',
                        0
                    );
                }
                _formData.append(
                    'mode',
                    dbType
                );
                _formData.append(
                    'details',
                    details
                );
                _formData.append(
                    'status',
                    '1'
                );
                _formData.append(
                    'addedby',
                    userName
                );
                _formData.append(
                    'ip_add',
                    ipAddress
                );
                _formData.append(
                    'location',
                    userLocation
                );
                // =================================================
                // UPDATE STOCK
                // =================================================
                const updatePromises =
                    drugData
                        .filter(
                            drug =>
                                drug &&
                                drug.id !== null &&
                                drug.id !== undefined &&
                                String(drug.id).trim() !== ''
                        )
                        .map(drug => {
                            const {
                                id,
                                qty
                            } = drug;
                            const pharmData = {
                                id: id,
                                qty: qty,
                                ip_add:
                                ipAddress
                            };
                            return axios.post(
                                `${baseUrl}update-indent-quantity/`,
                                pharmData
                            )
                                .catch(error => {
                                    console.log(error);
                                });
                        });
                Promise.all(
                    updatePromises
                )
                    .then(() => {
                        axios.post(
                            `${baseUrl}pharm-sale-other/`,
                            _formData
                        )
                            .then(response => {
                                if (
                                    response.status === 200 ||
                                    response.status === 201
                                ) {
                                    axios.put(
                                        baseUrl +
                                        'edit-case/' +
                                        did +
                                        '/',
                                        {
                                            drug_status: 2,
                                            ip_add: ipAddress
                                        }
                                    )
                                        .catch(error => {
                                            console.log(error);
                                        });
                                    Swal.fire({
                                        title:
                                            'Pharmacy Bill Generated.',
                                        icon:
                                            'success',
                                        timer:
                                            2000,
                                        showConfirmButton:
                                            false
                                    });
                                    setTimeout(() => {
                                        window.location.href =
                                            '/pharm-invoice-other/' +
                                            sale_id;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                Swal.fire(
                                    'Error!',
                                    'Failed to add entry. Please try again later.',
                                    'error'
                                );
                            });
                    })
                    .catch(error => {
                        console.log(error);
                        Swal.fire(
                            'Error!',
                            'Failed to update drug quantities. Please try again later.',
                            'error'
                        );
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate unique value. Please try again later.',
                    'error'
                );
            });
    };
    // ============================================================
    // CALCULATE DOCTOR MEDICINE NET AMOUNTS
    // ============================================================
    useEffect(() => {
        const lnetDefaultValues = [];
        opbillData.forEach((row) => {
            if (!row.drug_id) {
                return;
            }
            row.drug_id
                .split(',')
                .filter(test => test.trim() !== '')
                .forEach((test, subIndex) => {
                    const pharmData =
                        viewPharmData.find(
                            data =>
                                parseInt(data.id) ===
                                parseInt(test)
                        );
                    const lnetDefaultValue =
                        (
                            parseFloat(
                                lres[subIndex]
                            ) || 0
                        ) *
                        (
                            parseFloat(
                                pharmData?.product?.uamount
                            ) || 0
                        );
                    lnetDefaultValues.push(
                        lnetDefaultValue
                    );
                });
        });
        setLnet(
            lnetDefaultValues
        );
    }, [
        opbillData,
        viewPharmData,
        lres
    ]);
    // ============================================================
    // CONSULTANT OPTIONS
    // ============================================================
    const consul =
        opbillData.length > 0
            ? opbillData[0]?.appt?.cons?.id
            : '';
    // ============================================================
    // RENDER
    // ============================================================
    return (
        <section className="container mt-4">

            <form>

                {/* =================================================
                    PATIENT / CONSULTANT
                ================================================= */}

                <div className="row table-responsive">

                    <div className="col-md-12 col-12 mb-2">

                        <table className="erp-table-modern">

                            <thead>

                            <tr
                                style={{
                                    backgroundColor: '#1bc5ce',
                                    color: 'white'
                                }}
                            >

                                <th>Patient ID</th>

                                <th>Patient Name</th>

                                <th>Gender</th>

                                <th>D.O.B/Age</th>

                                <th>Consultant</th>

                            </tr>

                            </thead>


                            <tbody>

                            {opbillData.map(
                                (pat, index) => (
                                    <tr key={index}>

                                        <td
                                            style={{
                                                width: '10%'
                                            }}
                                        >

                                            <input
                                                className="form-control"
                                                type="text"
                                                name="patid"
                                                id="patid"
                                                value={
                                                    pat.pat?.id || ''
                                                }
                                                readOnly
                                            />

                                        </td>


                                        <td
                                            style={{
                                                width: '20%'
                                            }}
                                        >

                                            <input
                                                className="form-control"
                                                type="text"
                                                name="patient"
                                                id="patient"
                                                value={
                                                    pat.pat?.patient || ''
                                                }
                                                readOnly
                                            />

                                        </td>


                                        <td>
                                            {pat.pat?.gender}
                                        </td>


                                        <td>
                                            {pat.pat?.age}
                                        </td>


                                        <td>

                                            <select
                                                name="cons"
                                                id="cons"
                                                onChange={
                                                    handleConsChange
                                                }
                                                className="form-control"
                                                defaultValue={
                                                    pat.appt?.cons?.id || ''
                                                }
                                            >

                                                {consData.map(
                                                    (category, index) => (
                                                        <option
                                                            key={index}
                                                            value={
                                                                category.id
                                                            }
                                                        >

                                                            {
                                                                category.consultant
                                                            }

                                                        </option>
                                                    )
                                                )}

                                            </select>

                                        </td>

                                    </tr>
                                )
                            )}

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* =================================================
                    MEDICINES
                ================================================= */}

                <div className="table-responsive">

                    <table className="erp-table-modern">

                        <thead>

                        <tr
                            style={{
                                backgroundColor: '#1bc5ce',
                                color: 'white'
                            }}
                        >

                            <th style={{width: 60}}>
                                ID
                            </th>

                            <th style={{width: 150}}>
                                Drug Name
                            </th>

                            <th style={{width: 50}}>
                                Qty
                            </th>

                            <th style={{width: 100}}>
                                Batch
                            </th>

                            <th style={{width: 90}}>
                                Expiry
                            </th>

                            <th style={{width: 50}}>
                                Qty in Stock
                            </th>

                            <th style={{width: 110}}>
                                MRP 1s
                            </th>

                            <th style={{width: 110}}>
                                Net Amount
                            </th>

                        </tr>

                        </thead>


                        <tbody>

                        {/* =================================================
                                DOCTOR REQUESTED MEDICINES
                            ================================================= */}

                        {opbillData.map(
                            (row, index) => {
                                if (!row.drug_id) {
                                    return null;
                                }
                                return row.drug_id
                                    .split(',')
                                    .map(item => item.trim())
                                    .filter(item => item !== '')
                                    .map(
                                        (test, subIndex) => {
                                            const pharmData =
                                                viewPharmData.find(
                                                    data =>
                                                        parseInt(data.id) ===
                                                        parseInt(test)
                                                );
                                            if (!pharmData) {
                                                return null;
                                            }
                                            const uniqueKey =
                                                `${index}-${subIndex}`;
                                            const defaultValueItem =
                                                uniqueItems.find(
                                                    item =>
                                                        String(
                                                            item?.product?.id
                                                        ) ===
                                                        String(
                                                            pharmData?.product?.id
                                                        )
                                                );
                                            return (
                                                <tr
                                                    key={uniqueKey}
                                                >

                                                    <td>

                                                        <input
                                                            type="text"
                                                            name={`id-${index}`}
                                                            id={`id-${index}`}
                                                            value={
                                                                pharmData?.id || ''
                                                            }
                                                            onChange={
                                                                (e) =>
                                                                    handleChange(
                                                                        e,
                                                                        index
                                                                    )
                                                            }
                                                            style={{
                                                                width: 60
                                                            }}
                                                            tabIndex={-1}
                                                            readOnly
                                                        />

                                                    </td>


                                                    <td>

                                                        <AutoComplete

                                                            value={
                                                                defaultValueItem ||
                                                                null
                                                            }

                                                            options={
                                                                uniqueItems
                                                            }

                                                            sx={{
                                                                width: 250
                                                            }}

                                                            componentsProps={{
                                                                paper: {
                                                                    sx: {
                                                                        width: 800
                                                                    }
                                                                }
                                                            }}

                                                            fullWidth

                                                            onKeyDown={
                                                                e =>
                                                                    handleKeyDown(
                                                                        e,
                                                                        uniqueKey
                                                                    )
                                                            }

                                                            onChange={
                                                                (event, val) =>
                                                                    handleSelect(
                                                                        event,
                                                                        val,
                                                                        index
                                                                    )
                                                            }

                                                            getOptionLabel={
                                                                option =>
                                                                    option?.product?.product ||
                                                                    ''
                                                            }

                                                            isOptionEqualToValue={
                                                                (option, value) =>
                                                                    String(
                                                                        option?.product?.id
                                                                    ) ===
                                                                    String(
                                                                        value?.product?.id
                                                                    )
                                                            }

                                                            filterOptions={
                                                                customFilterOptions
                                                            }

                                                            renderOption={
                                                                (props, option) => (
                                                                    <Box
                                                                        component="li"
                                                                        {...props}
                                                                        sx={{
                                                                            width: 750,
                                                                            height: 50,
                                                                            borderRadius: 1
                                                                        }}
                                                                    >

                                                                        {
                                                                            option?.product
                                                                                ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch} TQty: ${option.qty}`
                                                                                : ''
                                                                        }

                                                                    </Box>
                                                                )
                                                            }

                                                            renderInput={
                                                                (params) => (
                                                                    <div
                                                                        ref={
                                                                            params.InputProps.ref
                                                                        }
                                                                    >

                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            {...params.inputProps}
                                                                            style={{
                                                                                background: "#F7EEFF",
                                                                                width: 250
                                                                            }}
                                                                        />

                                                                    </div>
                                                                )
                                                            }

                                                            ref={
                                                                el =>
                                                                    inputRefs.current[index] = el
                                                            }

                                                        />

                                                    </td>


                                                    <td>

                                                        <input
                                                            type="number"
                                                            style={{
                                                                width: 90
                                                            }}
                                                            name={`qty-${index}`}
                                                            id={`qty-${index}`}
                                                            value={
                                                                lres[subIndex] || ''
                                                            }
                                                            data-uamount={
                                                                pharmData?.product?.uamount
                                                            }
                                                            data-totqty={
                                                                pharmData?.qty
                                                            }
                                                            onChange={
                                                                (e) => {
                                                                    const value =
                                                                        e.target.value;
                                                                    if (
                                                                        value >= 0
                                                                    ) {
                                                                        const updatedLres =
                                                                            lres.map(
                                                                                (item, i) =>
                                                                                    i === subIndex
                                                                                        ? value
                                                                                        : item
                                                                            );
                                                                        setLres(
                                                                            updatedLres
                                                                        );
                                                                        handleAmountChange(
                                                                            e,
                                                                            subIndex
                                                                        );
                                                                    }
                                                                }
                                                            }
                                                            onKeyDown={
                                                                e =>
                                                                    handleKeyDown(
                                                                        e,
                                                                        uniqueKey
                                                                    )
                                                            }
                                                            tabIndex={0}
                                                            required
                                                        />

                                                    </td>


                                                    <td>

                                                        <input
                                                            type="text"
                                                            style={{
                                                                width: 120
                                                            }}
                                                            name="batch"
                                                            value={
                                                                pharmData?.product?.batch || ''
                                                            }
                                                            readOnly
                                                            tabIndex={-1}
                                                        />

                                                    </td>


                                                    <td>

                                                        <input
                                                            type="text"
                                                            style={{
                                                                width: 90
                                                            }}
                                                            name="expiry"
                                                            value={
                                                                pharmData?.product?.expiry || ''
                                                            }
                                                            readOnly
                                                            tabIndex={-1}
                                                        />

                                                    </td>


                                                    <td>

                                                        <input
                                                            type="number"
                                                            style={{
                                                                width: 90
                                                            }}
                                                            name={`totqty-${subIndex}`}
                                                            id={`totqty-${subIndex}`}
                                                            value={
                                                                pharmData?.qty || 0
                                                            }
                                                            tabIndex={-1}
                                                            readOnly
                                                        />

                                                    </td>


                                                    <td>

                                                        <input
                                                            type="number"
                                                            style={{
                                                                width: 90
                                                            }}
                                                            name="uamount"
                                                            value={
                                                                pharmData?.product?.uamount || 0
                                                            }
                                                            readOnly
                                                            tabIndex={-1}
                                                        />

                                                    </td>


                                                    <td>

                                                        <input
                                                            type="number"
                                                            style={{
                                                                width: 140
                                                            }}
                                                            name={`netamount-${index}`}
                                                            id={`netamount-${index}`}
                                                            value={
                                                                lnet[subIndex] || 0
                                                            }
                                                            tabIndex={-1}
                                                            readOnly
                                                        />

                                                    </td>


                                                    <button
                                                        className="btn btn-danger"
                                                        style={{
                                                            display: 'none'
                                                        }}
                                                        type="button"
                                                        onClick={
                                                            e =>
                                                                handleDeleteRow(
                                                                    e,
                                                                    uniqueKey
                                                                )
                                                        }
                                                    >
                                                        Delete
                                                    </button>

                                                </tr>
                                            );
                                        }
                                    );
                            }
                        )}


                        {/* =================================================
                                NEW MEDICINES
                            ================================================= */}

                        {rows.map(
                            (row, rowIndex) => {
                                if (!row) {
                                    return null;
                                }
                                const selectedOption =
                                    uniqueItems.find(
                                        item =>
                                            String(
                                                item?.product?.id
                                            ) ===
                                            String(
                                                row?.product
                                                    ? item?.product?.id
                                                    : ''
                                            )
                                    );
                                /*
                                 * Better match using product name.
                                 */
                                const currentValue =
                                    uniqueItems.find(
                                        item =>
                                            item?.product?.product ===
                                            row?.product
                                    ) || null;
                                return (
                                    <tr
                                        key={`new-${rowIndex}`}
                                    >

                                        <td>

                                            <input
                                                type="text"
                                                name="id"
                                                value={
                                                    row.id || ''
                                                }
                                                style={{
                                                    width: 60
                                                }}
                                                tabIndex={-1}
                                                readOnly
                                            />

                                        </td>


                                        <td>

                                            <AutoComplete

                                                value={
                                                    currentValue
                                                }

                                                options={
                                                    uniqueItems
                                                }

                                                sx={{
                                                    width: 200
                                                }}

                                                componentsProps={{
                                                    paper: {
                                                        sx: {
                                                            width: 800
                                                        }
                                                    }
                                                }}

                                                fullWidth

                                                onKeyDown={
                                                    e =>
                                                        handleKeyDownr(
                                                            e,
                                                            rowIndex
                                                        )
                                                }

                                                onChange={
                                                    (event, val) =>
                                                        handleSelect(
                                                            event,
                                                            val,
                                                            rowIndex
                                                        )
                                                }

                                                getOptionLabel={
                                                    option =>
                                                        option?.product?.product ||
                                                        ''
                                                }

                                                isOptionEqualToValue={
                                                    (option, value) =>
                                                        String(
                                                            option?.product?.id
                                                        ) ===
                                                        String(
                                                            value?.product?.id
                                                        )
                                                }

                                                filterOptions={
                                                    customFilterOptions
                                                }

                                                renderOption={
                                                    (props, option) => (
                                                        <Box
                                                            component="li"
                                                            {...props}
                                                            sx={{
                                                                width: 750,
                                                                height: 50,
                                                                borderRadius: 1
                                                            }}
                                                        >

                                                            {
                                                                option?.product
                                                                    ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch} TQty: ${option.qty}`
                                                                    : ''
                                                            }

                                                        </Box>
                                                    )
                                                }

                                                renderInput={
                                                    (params) => (
                                                        <div
                                                            ref={
                                                                params.InputProps.ref
                                                            }
                                                        >

                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                {...params.inputProps}
                                                                style={{
                                                                    background: "#F7EEFF",
                                                                    width: 200
                                                                }}
                                                            />

                                                        </div>
                                                    )
                                                }

                                                ref={
                                                    el =>
                                                        inputRefs.current[
                                                            rowIndex
                                                            ] = el
                                                }

                                            />

                                        </td>


                                        <td>

                                            <input
                                                type="number"
                                                style={{
                                                    width: 90
                                                }}
                                                min={0}
                                                step="1"
                                                value={
                                                    row.qty ?? ''
                                                }
                                                name="qty"
                                                onChange={
                                                    (e) => {
                                                        const value =
                                                            e.target.value;
                                                        if (
                                                            !/^\d*$/.test(
                                                                value
                                                            )
                                                        ) {
                                                            return;
                                                        }
                                                        handleChanger(
                                                            e,
                                                            rowIndex
                                                        );
                                                        handleAmountChanger(
                                                            e,
                                                            rowIndex
                                                        );
                                                    }
                                                }
                                                onKeyDown={
                                                    (e) => {
                                                        if (
                                                            e.key === "." ||
                                                            e.key === "e" ||
                                                            e.key === "-"
                                                        ) {
                                                            e.preventDefault();
                                                        }
                                                        handleKeyDownr(
                                                            e,
                                                            rowIndex
                                                        );
                                                    }
                                                }
                                                tabIndex={0}
                                                required

                                                /*
                                                 * CRITICAL:
                                                 * Every new row gets
                                                 * its own quantity ref.
                                                 */
                                                ref={
                                                    el =>
                                                        qtyInputRefs.current[
                                                            rowIndex
                                                            ] = el
                                                }

                                            />

                                        </td>


                                        <td>

                                            <input
                                                type="text"
                                                style={{
                                                    width: 120
                                                }}
                                                name="batch"
                                                value={
                                                    row.batch || ''
                                                }
                                                readOnly
                                                tabIndex={-1}
                                            />

                                        </td>


                                        <td>

                                            <input
                                                type="text"
                                                style={{
                                                    width: 90
                                                }}
                                                name="expiry"
                                                value={
                                                    row.expiry || ''
                                                }
                                                readOnly
                                                tabIndex={-1}
                                            />

                                        </td>


                                        <td>

                                            <input
                                                type="number"
                                                style={{
                                                    width: 90
                                                }}
                                                name="totqty"
                                                value={
                                                    row.totqty || ''
                                                }
                                                readOnly
                                                tabIndex={-1}
                                            />

                                        </td>


                                        <td>

                                            <input
                                                type="number"
                                                style={{
                                                    width: 120
                                                }}
                                                name="uamount"
                                                value={
                                                    row.uamount || ''
                                                }
                                                readOnly
                                                tabIndex={-1}
                                            />

                                        </td>


                                        <td>

                                            <input
                                                type="number"
                                                style={{
                                                    width: 140
                                                }}
                                                name="netamount"
                                                value={
                                                    row.netamount || 0
                                                }
                                                tabIndex={-1}
                                                readOnly
                                            />

                                        </td>


                                        <button
                                            className="btn btn-danger"
                                            style={{
                                                display: 'none'
                                            }}
                                            type="button"
                                            onClick={
                                                e =>
                                                    handleDeleteRowr(
                                                        e,
                                                        rowIndex
                                                    )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </tr>
                                );
                            }
                        )}

                        </tbody>

                    </table>


                    {/* =================================================
                        ADD MORE
                    ================================================= */}

                    <button
                        className="btn btn-success addmore mt-4"
                        type="button"
                        onClick={handleAddRow}
                    >
                        Add More
                    </button>


                    {/* =================================================
                        TOTALS
                    ================================================= */}

                    <div className="row ms-5 mt-5">

                        <div className="col-md-6">

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                                className="ms-5"
                            >

                                <div className="form-group">

                                    <label
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Subtotal: &nbsp;
                                    </label>

                                    <div className="input-group">

                                        <div className="input-group-addon me-2">
                                            &#8377;
                                        </div>

                                        <input
                                            type="number"
                                            value={
                                                subtotal
                                            }
                                            readOnly
                                        />

                                    </div>

                                </div>


                                <div className="form-group mt-3">

                                    <label
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Discount: &nbsp;
                                    </label>

                                    <div className="input-group">

                                        <div className="input-group-addon me-2">
                                            %
                                        </div>

                                        <input
                                            type="number"
                                            value={
                                                disPer
                                            }
                                            name="disPer"
                                            id="disPer"
                                            onChange={
                                                handleDisPerChange
                                            }
                                        />

                                    </div>

                                </div>


                                <div className="form-group mt-3">

                                    <label
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Discount Amount: &nbsp;
                                    </label>

                                    <div className="input-group">

                                        <div className="input-group-addon me-2">
                                            &#8377;
                                        </div>

                                        <input
                                            type="number"
                                            name="disc"
                                            id="disc"
                                            value={
                                                disc
                                            }
                                            readOnly
                                        />

                                    </div>

                                </div>


                                <div className="form-group mt-3">

                                    <label
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Total: &nbsp;
                                    </label>

                                    <div className="input-group">

                                        <div className="input-group-addon me-2">
                                            &#8377;
                                        </div>

                                        <input
                                            type="number"
                                            name="tot"
                                            value={
                                                total
                                            }
                                            readOnly
                                        />

                                    </div>

                                </div>

                            </div>

                        </div>


                        <div className="col-md-6">

                            <div className="form-group">

                                <label>
                                    Choose Payment Type
                                </label>

                                <select
                                    name="dbType"
                                    id="dbType"
                                >

                                    <option value="cash">
                                        Cash
                                    </option>

                                    <option value="card">
                                        Card
                                    </option>

                                    <option value="creditpay">
                                        Credit Payment
                                    </option>

                                    <option value="UPI">
                                        UPI
                                    </option>

                                </select>

                            </div>


                            <div className="form-group">

                                <label>
                                    Details:
                                </label>

                                <textarea
                                    className="no-comma form-control"
                                    tabIndex="0"
                                    name="details"
                                    id="details"
                                    rows={2}
                                    cols={2}
                                />

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        SUBMIT
                    ================================================= */}

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        className="mb-5"
                    >

                        <button
                            type="button"
                            onClick={formSubmit}
                            className="btn btn-primary mt-4"
                        >
                            Submit
                        </button>

                    </div>

                </div>

            </form>

        </section>
    );
};
export default DrugPayDr;